import { SelectOption } from "@/shared/components";

type MaterieelType = "DDZ" | "Flirt" | "ICM" | "ICNG" | "SLT" | "SNG" | "VIRM" | "Overig";

const materieelTypeOptions: SelectOption<MaterieelType>[] = [
    { value: "DDZ", label: "DDZ" },
    { value: "Flirt", label: "Flirt" },
    { value: "ICM", label: "ICM" },
    { value: "ICNG", label: "ICNG" },
    { value: "SLT", label: "SLT" },
    { value: "SNG", label: "SNG" },
    { value: "VIRM", label: "VIRM" },
    { value: "Overig", label: "Overig" },
];

export function getMaterieelTypeOptions(aanduiding?: string): SelectOption<MaterieelType>[] {
    // add aanduiding to the list op options if it is not already there (the type in Spoorweb is a string, our select list is an educated guess of the expected values)
    if (!aanduiding) {
        return materieelTypeOptions;
    }

    const isInOptions = materieelTypeOptions.some((option) => option.value === aanduiding);

    if (isInOptions) {
        return materieelTypeOptions;
    }

    return [...materieelTypeOptions, { value: aanduiding as MaterieelType, label: aanduiding }];
}

export function createMaterieel(materieelAanduiding?: string, materieelAantalBakken?: string) {
    return materieelAanduiding && materieelAantalBakken
        ? { aanduiding: materieelAanduiding, aantalBakken: Number(materieelAantalBakken) }
        : undefined;
}
